import { GroupByPipe } from './pipes/groupBy.directive';
import { TranslateModule } from '@ngx-translate/core';
import { SearchFilterPipe } from './pipes/searchpipe.directive';

import { AvatarComponent } from './avatar/avatar.component';
import { NgModule } from '@angular/core';

import { MenuItems } from './menu-items/menu-items';
import { GtMenuItems } from './menu-items/gt-menu-items';
import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { ToggleFullscreenDirective } from './fullscreen/toggle-fullscreen.directive';
import { BackgroundDirective } from './background/background.directive';
import { TruncateModule } from 'ng2-truncate';

@NgModule({
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    AvatarComponent,
    BackgroundDirective,
    SearchFilterPipe,
    GroupByPipe
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    AvatarComponent,
    BackgroundDirective,
    TruncateModule,
    SearchFilterPipe,
    GroupByPipe,
    TranslateModule
   ],
  providers: [ MenuItems,GtMenuItems ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/shared/shared.module.ts